export default __webpack_public_path__ + "static/media/012-wifi router.ace8f981.svg";